/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateInventoryCategoryCommand,
    CreateInventoryCategoryCommandFromJSON,
    CreateInventoryCategoryCommandToJSON,
    ExceptionDto,
    ExceptionDtoFromJSON,
    ExceptionDtoToJSON,
    GetAllInventoryCategoriesQuery,
    GetAllInventoryCategoriesQueryFromJSON,
    GetAllInventoryCategoriesQueryToJSON,
    InventoryCategoryVmPaginatedSearchResponse,
    InventoryCategoryVmPaginatedSearchResponseFromJSON,
    InventoryCategoryVmPaginatedSearchResponseToJSON,
    UpdateInventoryCategoryCommand,
    UpdateInventoryCategoryCommandFromJSON,
    UpdateInventoryCategoryCommandToJSON,
} from '../models';

export interface ApiInventoryCategoryInventorycategoryIdPutRequest {
    id: string;
    updateInventoryCategoryCommand?: UpdateInventoryCategoryCommand;
}

export interface ApiInventoryCategoryInventorycategoryPostRequest {
    createInventoryCategoryCommand?: CreateInventoryCategoryCommand;
}

export interface ApiInventoryCategoryPostRequest {
    getAllInventoryCategoriesQuery?: GetAllInventoryCategoriesQuery;
}

/**
 * 
 */
export class InventoryCategoryApi extends runtime.BaseAPI {

    /**
     * Update an inventory category
     */
    async apiInventoryCategoryInventorycategoryIdPutRaw(requestParameters: ApiInventoryCategoryInventorycategoryIdPutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiInventoryCategoryInventorycategoryIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/InventoryCategory/inventorycategory/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInventoryCategoryCommandToJSON(requestParameters.updateInventoryCategoryCommand),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an inventory category
     */
    async apiInventoryCategoryInventorycategoryIdPut(requestParameters: ApiInventoryCategoryInventorycategoryIdPutRequest): Promise<void> {
        await this.apiInventoryCategoryInventorycategoryIdPutRaw(requestParameters);
    }

    /**
     * Create an inventory category
     */
    async apiInventoryCategoryInventorycategoryPostRaw(requestParameters: ApiInventoryCategoryInventorycategoryPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/InventoryCategory/inventorycategory`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateInventoryCategoryCommandToJSON(requestParameters.createInventoryCategoryCommand),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create an inventory category
     */
    async apiInventoryCategoryInventorycategoryPost(requestParameters: ApiInventoryCategoryInventorycategoryPostRequest): Promise<string> {
        const response = await this.apiInventoryCategoryInventorycategoryPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get all inventory categories.
     */
    async apiInventoryCategoryPostRaw(requestParameters: ApiInventoryCategoryPostRequest): Promise<runtime.ApiResponse<InventoryCategoryVmPaginatedSearchResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/InventoryCategory`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAllInventoryCategoriesQueryToJSON(requestParameters.getAllInventoryCategoriesQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InventoryCategoryVmPaginatedSearchResponseFromJSON(jsonValue));
    }

    /**
     * Get all inventory categories.
     */
    async apiInventoryCategoryPost(requestParameters: ApiInventoryCategoryPostRequest): Promise<InventoryCategoryVmPaginatedSearchResponse> {
        const response = await this.apiInventoryCategoryPostRaw(requestParameters);
        return await response.value();
    }

}
